














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import ImageGallery from '@/plugins/ImageGallery/imageGallery';
import ImageGalleryModal from '@/components/Editor/ImageGalleryModal';

@Component({ components: { ImageGalleryModal } })
export default class Editor extends Vue {
  @Prop() value!: string;

  editor = ClassicEditor;
  editorConfig: object = {
    plugins: [
      Alignment,
      Essentials,
      Autoformat,
      Font,
      Bold,
      Italic,
      Underline,
      BlockQuote,
      Heading,
      Image,
      ImageCaption,
      ImageStyle,
      ImageToolbar,
      ImageGallery,
      Link,
      List,
      MediaEmbed,
      Paragraph,
      PasteFromOffice,
      Table,
      TableToolbar,
    ],

    fontSize: {
      options: [
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        'default',
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
      ],
    },

    toolbar: {
      items: [
        'heading',
        '|',
        'fontSize',
        '|',
        'alignment',
        '|',
        'bold',
        'italic',
        'underline',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'insertImage',
        'blockQuote',
        'insertTable',
        'mediaEmbed',
        '|',
        'undo',
        'redo',
      ],
      image: {
        toolbar: [
          'imageStyle:full',
          'imageStyle:side',
          '|',
          'imageTextAlternative',
        ],
      },
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
      },
      language: 'en',
    },
  };
  toggleEditMode: number = 0;
  codemirrorOptions: object = {
    mode: 'htmlmixed',
    tabSize: 4,
    lineNumbers: true,
    lineWrapping: true,
    matchTags: true,
    closeTag: true,
    viewportMargin: Infinity,
  };

  get listeners() {
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  onInput(content: string) {
    this.$emit('input', content);
  }
}
